@if (event) {
  <div
    class="ticket-order-card-cont"
    [class.header-view]="headerView"
    (click)="onSelectOrder()"
  >
    <div class="ticket-order-img-cont">
      <img
        [src]="event.getEncodedMainImage(true)"
        class="key-visual-img"
        alt="Key Visual"
      />
    </div>
    <div class="ticket-order-cont">
      @if (!headerView) {
        <div class="name">
          {{ event.name }} | {{ order.getOrderDisplayName() }}
        </div>
      }
      <div class="date-address">
        <div class="date icon-item">
          <div class="icon">
            <i class="fa-regular fa-calendar-day icon-small"></i>
          </div>
          <div class="item">
            @if (order.eventSlot) {
              {{ order.eventSlot.getSlotDateDisplay(currentLang) }}
            } @else {
              {{ event.getDisplayDate() }}
            }
          </div>
        </div>
        <div class="location icon-item">
          <div class="icon">
            <i class="fa-regular fa-location-dot icon-small"></i>
          </div>
          <div class="item">
            {{ event.getAddressDisplayNameOrderCard() }}
          </div>
        </div>
      </div>
      <div class="order-tickets icon-item">
        <div class="icon">
          <i class="fa-regular fa-ticket icon-small"></i>
        </div>
        <div class="item">
          {{ order.eventAttendeeTickets.length }}
          @if (order.eventAttendeeTickets.length === 1) {
            {{ "APP.TICKETS_DASHBOARD.TICKET" | translate }}
          } @else {
            {{ "APP.TICKETS_DASHBOARD.TICKETS" | translate }}
          }
        </div>
      </div>
      <div class="refund-wrapper icon-item">
        <div class="refund-info">
          @if (
            !hasRequestedRefund() &&
            (changeSlotAvailable || refundAvailable) &&
            headerView
          ) {
            <div class="title clickable" [matMenuTriggerFor]="appMenu">
              {{ "APP.REQUEST_REFUND.PROBLEM_WITH_ORDER" | translate }}
              <i class="fa-regular fa-chevron-right"></i>
            </div>
          } @else if (hasRequestedRefund() && !headerView) {
            <div class="title">
              <i class="fa-regular" [ngClass]="getRefundProgressIcon()"></i>
              {{ getRefundProgress() }}
            </div>
          }
        </div>
        <mat-menu #appMenu="matMenu" class="mat-menu-actions-container mb-1">
          @if (changeSlotAvailable) {
            <button mat-menu-item (click)="changeTimeslot()">
              {{ "APP.REQUEST_REFUND.WRONG_SLOT_SELECTED" | translate }}
            </button>
          }
          @if (refundAvailable) {
            <button mat-menu-item (click)="requestRefund()">
              {{ "APP.REQUEST_REFUND.REFUND_THE_ORDER" | translate }}
            </button>
          }
        </mat-menu>
      </div>
    </div>
    @if (!headerView && !order.allTicketsAssigned()) {
      <div class="ticket-order-warning-cont">
        <i
          class="fa-regular fa-circle-exclamation icon-regular warning-icon"
        ></i>
      </div>
    }
  </div>
}
